import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../store/authContext';

export default function PrivateRoute() {
  const { session } = useAuth();
  const location = useLocation();

  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  return <Outlet />;
}
